import TMIndex from "@/views/App/TimeManagement/TMIndex.vue"
import TMMonthlyOverview from "@/views/App/TimeManagement/TMMonthlyOverview/List.vue"
import TMOverview from "@/views/App/TimeManagement/Overview.vue"
import TMAnnualOverview from "@/views/App/TimeManagement/TMAnnualOverview/List.vue"
import TMCoordinatorMonthlyOverview from "@/views/App/TimeManagement/TMCoordinatorMonthlyOverview/List.vue"
import TMCoordinatorAnnualOverview from "@/views/App/TimeManagement/TMCoordinatorAnnualOverview/List.vue"
import TMPendingMonthsForApproval from "@/views/App/TimeManagement/TMMonthsForApproval/List.vue"
import {UserRole} from "@/shared/enums/UserRolesEnums"

const routesTimeManagement = [
    {
        path: 'hourly-overview/:id?',
        name: 'hourlyOverview',
        meta: {
            roles: [
                UserRole.ADMIN,
                UserRole.COACH,
                UserRole.PERSONAL,
                UserRole.HEAD_OF_HR,
                UserRole.SITE_MANAGER,
                UserRole.SITE_SUPPORT,
                UserRole.HEAD_OF_AMDL,
                UserRole.HEAD_OF_MARKETING,
                UserRole.HEAD_OF_PSYCHOSOCIAL_SERVICES,
                UserRole.PRACTICE_MANAGER,
                UserRole.HEAD_OF_OCCUPATIONAL_THERAPY,
                UserRole.ASSISTANT_VQ,
                UserRole.ACCOUNTANT,
            ]
        },
        component: TMIndex
    },
    {
        path: 'monthly-overview',
        name: 'monthlyOverview',
        component: TMMonthlyOverview,
        meta: {
            roles: [
                UserRole.ADMIN,
                UserRole.PERSONAL,
                UserRole.HEAD_OF_HR
            ]
        },
    },
    {
        path: 'monthly-overview',
        name: 'monthlyOverviewForApproval',
        component: TMMonthlyOverview,
        meta: {
            roles: [
                UserRole.ADMIN,
                UserRole.PERSONAL,
                UserRole.HEAD_OF_HR
            ]
        },
    },
    {
        path: 'overview/:id?',
        name: 'overview',
        component: TMOverview,
        meta: {
            roles: [
                UserRole.COACH,
                UserRole.THERAPIST,
                UserRole.ADMIN,
                UserRole.PERSONAL,
                UserRole.HEAD_OF_HR,
                UserRole.SITE_MANAGER,
                UserRole.HEAD_OF_AMDL,
                UserRole.HEAD_OF_MARKETING,
                UserRole.HEAD_OF_PSYCHOSOCIAL_SERVICES,
                UserRole.HEAD_OF_OCCUPATIONAL_THERAPY,
            ]
        },
    },
    {
        path: 'annual-overview',
        name: 'annualOverview',
        component: TMAnnualOverview,
        meta: {
            roles: [
                UserRole.ADMIN,
                UserRole.PERSONAL,
                UserRole.HEAD_OF_HR
            ]
        },
    },
    {
        path: 'monthly-overview/coordinator',
        name: 'monthlyOverviewCoordinator',
        component: TMCoordinatorMonthlyOverview,
        meta: {
            roles: [
                UserRole.ADMIN,
                UserRole.PERSONAL,
                UserRole.HEAD_OF_HR,
                UserRole.SITE_MANAGER,
                UserRole.HEAD_OF_AMDL,
                UserRole.HEAD_OF_MARKETING,
                UserRole.HEAD_OF_PSYCHOSOCIAL_SERVICES,
                UserRole.HEAD_OF_OCCUPATIONAL_THERAPY,
            ]
        },
    },
    {
        path: 'annual-overview/coordinator',
        name: 'annualOverviewCoordinator',
        component: TMCoordinatorAnnualOverview,
        meta: {
            roles: [
                UserRole.ADMIN,
                UserRole.PERSONAL,
                UserRole.HEAD_OF_HR,
                UserRole.SITE_MANAGER,
                UserRole.HEAD_OF_AMDL,
                UserRole.HEAD_OF_MARKETING,
                UserRole.HEAD_OF_PSYCHOSOCIAL_SERVICES,
                UserRole.HEAD_OF_OCCUPATIONAL_THERAPY,
            ]
        },
    },
    {
        path: 'pending-months-for-approval',
        name: 'tmPendingMonthsForApproval',
        component: TMPendingMonthsForApproval,
        meta: {
            roles: [
                UserRole.ADMIN,
                UserRole.PERSONAL,
                UserRole.HEAD_OF_HR
            ]
        },
    }
];

export default routesTimeManagement;